import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import { hideModal } from '../../actions/_modal'
import { getGradeLevels } from '../../selectors/manifest'
import Phase from './Phase'
import FlexContainer from '../styled/FlexContainer'
import { setMasterCourseFilter } from '../../actions/mycourses'
import { Caption1 } from '../styled/typography/typography'
import { CourseLink } from './_Styled'
import { getJourneysGroupedByMasterCourse } from 'selectors/usercourses'
import useLexicon from '../../hooks/useLexicon'
import { useTheme } from 'styled-components'
import { getTint } from '../../utils/color'

const PhaseMasterCourseJourneyLevelLink = ({
  dispatch,
  source,
  userId,
  studentId,
  level,
  gradeLevels,
  masterCourse,
  courseEnrollments,
  truncateLongCourse,
  useMasterCourseAbbreviation,
  linkCourseNameOnly = false
}) => {
  const lexicon = useLexicon()
  const theme = useTheme()

  const [hovered, setHovered] = useState(false)

  const getGradeLevel = () =>
    gradeLevels.find(gl => gl.id === masterCourse.master_course.grade_level_id)

  const getLevelText = () =>
    `${
      !level.mastery ? lexicon.level + level.number : `Mastery ${lexicon.level}`
    }`

  const onMouseOver = () => {
    setHovered(true)
  }

  const onMouseOut = () => {
    setHovered(false)
  }

  const onClick = e => {
    e.stopPropagation()
    dispatch(hideModal())

    // check if the MC will be listed in My Courses
    const courseFilterValue = courseEnrollments.find(
      e => e.masterCourse.id === masterCourse.master_course.id
    )
      ? masterCourse.master_course.id
      : -1

    if (courseFilterValue === -1 && !!studentId) {
      // My Courses won't have it, but we got to this quest page somehow
      // (presumably Student Profile), so try going there and scroll to the course
      dispatch(push(`/user/${studentId}/studentcourses#m-course-${masterCourse.master_course.id}`))
    } else {
      dispatch(setMasterCourseFilter(courseFilterValue))
      dispatch(
        push(
          `/user/${userId}/courses/${
            courseFilterValue > -1 ? courseFilterValue : ''
          }`
        )
      )
    }
  }

  const color =
    theme?.style === 'dark'
      ? getTint(masterCourse?.master_course?.color, 0.3)
      : `${masterCourse?.master_course?.color}`

  return masterCourse ? (
    truncateLongCourse ? (
      <FlexContainer
        tabIndex="0"
        className="course-name course-level-indicator"
        style={{ cursor: 'pointer' }}
        onClick={onClick}
        onKeyPress={onClick}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
      >
        <Phase size={16} phase={getGradeLevel()} />
        <CourseLink
          className="course"
          color={color}
          hovered={hovered}
          lineHeight="unset"
        >
          {useMasterCourseAbbreviation
            ? masterCourse.master_course.abbreviation
            : masterCourse.master_course.name}
          : {masterCourse.course.name}
        </CourseLink>
        <Caption1
          className="level"
          onClick={
            linkCourseNameOnly
              ? e => {
                  e.preventDefault()
                  e.stopPropagation()
                }
              : null
          }
        >
          {getLevelText()}
        </Caption1>
      </FlexContainer>
    ) : (
      <FlexContainer
        tabIndex="0"
        className="course-name course-level-indicator"
        style={{
          justifyContent: 'flex-start',
          cursor: 'pointer'
        }}
        onClick={onClick}
        onKeyPress={onClick}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
      >
        <Phase size={16} phase={getGradeLevel()} />
        <CourseLink
          color={color}
          hovered={hovered}
          lineHeight="1.3"
          style={{ textAlign: 'left' }}
        >
          {useMasterCourseAbbreviation
            ? masterCourse.master_course.abbreviation
            : masterCourse.master_course.name}
          : {masterCourse.course.name}
          <Caption1
            as="span"
            style={{
              marginLeft: '6px'
            }}
            onClick={
              linkCourseNameOnly
                ? e => {
                    e.preventDefault()
                    e.stopPropagation()
                  }
                : null
            }
          >
            {getLevelText()}
          </Caption1>
        </CourseLink>
      </FlexContainer>
    )
  ) : null
}

PhaseMasterCourseJourneyLevelLink.defaultProps = {
  displayIconInsteadOfText: false,
  displayCourseSectionName: false,
  truncateLongCourse: true,
  useMasterCourseAbbreviation: false
}

PhaseMasterCourseJourneyLevelLink.propTypes = {
  gradeLevels: PropTypes.array,
  masterCourse: PropTypes.object,
  courseEnrollments: PropTypes.array,
  course: PropTypes.object,
  level: PropTypes.object,
  quest: PropTypes.object,
  displayIconInsteadOfText: PropTypes.bool,
  truncateLongCourse: PropTypes.bool,
  useMasterCourseAbbreviation: PropTypes.bool,
  userId: PropTypes.number.isRequired,
  studentId: PropTypes.number,
  source: PropTypes.string
}

export const mapStateToProps = state => ({
  gradeLevels: getGradeLevels(state),
  userId: state.auth.user.id,
  studentId: state.studentprofile.student?.id,
  courseEnrollments: getJourneysGroupedByMasterCourse({
    state,
    excludeNonAcademicYearCourses: true
  })
})

export default connect(mapStateToProps)(PhaseMasterCourseJourneyLevelLink)
